import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import logo from "../images/logo_black.png";

import Footer from "./components/Footer";

import "../css/style.css";

const Step50_Confirmation = () => {

    const theEvent = JSON.parse(sessionStorage.getItem("FUWEvent"));
    const remarks = JSON.parse(theEvent.remarks);

    const [resources, setResources] = useState({});
    const [orderId] = useState(sessionStorage.getItem("OrderId"));
    const [order, setOrder] = useState([]);

    const [error, setError] = useState(null);

    // fetching resources
    const { language } = useParams();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    useEffect(() => {
        loadToken();
    }, [language]);

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;

            requestResources();
        });
    };

    const requestResources = () => {
        axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
                confirmOrder();
                loadOrder(orderId);
            })
            .catch((error) => console.log(error.response.data));
    };

    const loadOrder = async (orderId, attempt = 1) => {
        try {
            const fetchedOrder = await getOrderByOrderId(orderId);

            // If invoiceNumber missing and attempts < 3, retry
            if ((!fetchedOrder?.invoiceNumber || fetchedOrder.invoiceNumber === "") && attempt < 7) {
                console.log(`Retrying to fetch order... Attempt ${attempt + 1}`);
                await new Promise((resolve) => setTimeout(resolve, 2000)); // optional delay before retry
                return loadOrder(orderId, attempt + 1);
            }

            if (!fetchedOrder?.invoiceNumber) {
                setError("Invoice number is missing after multiple attempts.");
            } else {
                setError(null);
            }

            setOrder(fetchedOrder);
        } catch (error) {
            console.error(error);
            setError("Failed to load order.");
        }
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    // confirm the order
    const confirmOrder = () => {
        axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`).catch((error) => console.error(error.response.data));
    };

    return (
        <div>

            {resources && (
                <div className="container pt-0 wrapper">
                    <div className="row mt-2">
                        <div className="col-md-4 text-center">
                            <img src={logo} className="img-fluid" alt="FUW Logo"></img>
                        </div>
                    </div>


                    {/* Show error message if any */}
                    {error && (
                        <div className="alert alert-danger mt-5" role="alert">
                            <p dangerouslySetInnerHTML={{ __html: resources?.ErrorOrder?.replaceAll("${orderId}", orderId) }}></p>
                        </div>
                    )}

                    {!error && order && order.invoiceNumber && order.invoiceNumber !== 0 && (
                        <>
                            <div className="row mt-4">
                                <div className="col-md-12 mt-5">
                                    <div dangerouslySetInnerHTML={{ __html: remarks["ConfirmationText"] }} className="description"></div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            )}

            <div className="container wrapper">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <Footer language={language} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step50_Confirmation;